import { connect } from "react-redux";
import { put, call, fork, select, race, spawn, cancelled, take } from "redux-saga/effects";
import { createAction } from "redux-delta";
import { callbackToBotSaga } from "../webview";
import { user } from '../user'
import { track } from '../mixpanel'


const startTutorial = createAction('START_TUTORIAL', () => 0);
const updateTutorialStatus = createAction('UPDATE_TUTORIAL_STATUS', increment)
const finishTutorial = createAction("FINISH_TUTORIAL", () => null);
const abortTutorial = createAction("ABORT_TUTORIAL", () => null);
const tutorialError = createAction("ERROR_TUTORIAL", (error) => ({ error }));

export const stateAgents = {
  startTutorial,
  updateTutorialStatus,
  finishTutorial,
  abortTutorial,
  tutorialError
}

// getState
const tutorialStatus = ({ tutorial }) =>  tutorial;


function* startTutorialSaga() {
  try {
    yield put(track("Tutorial Webview Open"))
    yield take(user.setSuccess.type)
  } catch(e) {
    yield put(tutorialError(e))
  }
}

function* tutorialEndSaga () {
  yield call(callbackToBotSaga, "___TUTORIAL_END_CUE___")
}

// watcher
function* tutorialSaga () {
  yield spawn(function*() {
    yield take(startTutorial.type)
    yield* startTutorialSaga()
    yield call(tutorialEndSaga)

    yield put(track("Tutorial Webview Finish"))
 })
}



//Tutorial HOC
export const withTutorialControl = connect(
  tutorialStatus,
  {
    start() {
      return startTutorial()
    },
    end() {
      return abortTutorial()
    }
  }
)

export default tutorialSaga

function increment(num) {
  return (num || 0) + 1
}



// WEBPACK FOOTER //
// ./src/store/tutorial/index.js